export default {
  buildTeam: '/m/takeReward1', // 建团
  joinBuildTeam: '/m/assistReward', // 参团
  isBuilder: '/m/isShareRoleInfo', // 判断角色是否是团长
  getJoinList: '/m/shareStatusInfo', //获取参与并激活列表接口(奖券)
  getTeamLeaderInfo:'/m/myShareInfo', //获取团长等信息
  isBuildTeam:'/m/isFinishedInfo', // 是否还可以建团
  isUserBeloneTeam: '/m/addTimes', // 是否是团成员接口
  getCouponList: '/m/rewardInfo', // 获取头像排行榜接口
  getLuckyRankingList: '/m/rewardsInfo', // 手气排行榜
  sendReward: '/m/assistPickUpReward', //领奖
}



// WEBPACK FOOTER //
// ./src/api/url.js